<template>
  <CModal @mtdclosemodal="mtdClose" :show="boo_modal" :title="title" :size="'md'" :centered="true" :btn_cancel="true"
    :btn_ok="true" :booTitile="true">
    <div>
      <CRow>
        <CCol xl="12" lg="12" md="12" sm="12">
          <CInput label="Adelanto" type="text" v-model="localAdvancePayment" :disabled=!isDisabledFPropPassed
            placeholder="0" @change="validateAdvancePayment" />
          <h6>MÉTODO DE PAGO</h6>
          <table>
            <tbody v-if="data_metodo_pago.length == 0">
              <tr>
                <td>Sin Metodos de Pago (Agregue en Mantenimiento)</td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr v-for="(item, index) in data_metodo_pago" :key="index">
                <td v-if="item.label != 'MIXTO'">{{ item.label }}</td>
                <td v-if="item.label != 'MIXTO'">
                  <input type="number" class="form-control" placeholder="0" min="0" v-model.number="item.amount"
                    @input="checkTotalAmount(index)" />
                </td>
              </tr>
            </tbody>
          </table>
        </CCol>
      </CRow>
    </div>
    <template #footer>
      <button @click="mtdClose" class="btn btn-sm">
        <i class="fa fa-times" />&nbsp;Cerrar
      </button>
      <button @click="mtd_action" :disabled="cpButton" class="btn btn-info btn-sm">
        <i class="fa fa-save"></i>&nbsp;Guardar
      </button>
      &nbsp;
    </template>
  </CModal>
</template>
<script>
import { mapActions } from "vuex";
import CModal from "../../../shared/modals/cModalFormCom.vue";
import { CCol, CRow } from "@coreui/vue-pro";

export default {
  name: "c-payment-modal",
  components: {
    CModal,
  },
  data() {
    return {
      prefix: "cita",
      data_metodo_pago: [],
      localAdvancePayment: "",
      fech_advance: new Date().toISOString().split('T')[0],
      quote: {},
      total_quote: "",
    };
  },
  props: {
    title: String,
    boo_modal: Boolean,
    item: Object,
    advance_payment: Number,
    disabled_f: Boolean,
    typeRecording: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    boo_modal(newVal){
      if(newVal){
        this.showMethodPayment();
      }
    },
    advance_payment(newVal) {
      this.localAdvancePayment = Number(newVal) == 0 ? "" : Number(newVal);
    },
    item(newVal) {
      if (newVal && typeof newVal === "object" && "total" in newVal) {
        this.quote = newVal;
        this.total_quote = this.quote.total;
      } else {
        this.quote = {};
        this.total_quote = 0; // Valor predeterminado si no se proporciona un TOTAL.
      }
    },
  },
  computed: {
    cpButton() {
      return false;
    },
    isDisabledFPropPassed() {
      return (this.$props.disabled_f);
    },
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdClose() {
      this.data_metodo_pago = [];
      this.$emit("closeModalPaymentMethod");
    },
    showMethodPayment() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/byMethodPayment/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          response.data.data.forEach((arr) => {
            const { Id, name } = arr;
            this.data_metodo_pago.push({
              label: name,
              value: Id,
              amount: "",
            });
          });
        })
        .catch((errors) => { });
    },
    checkTotalAmount(index) {
      const totalExcludingCurrent = this.data_metodo_pago.reduce((sum, item, i) => {
        return i !== index ? sum + Number(item.amount || 0) : sum;
      }, 0);

      const currentItem = this.data_metodo_pago[index];
      const maxAmountForCurrent = Number(this.localAdvancePayment) - totalExcludingCurrent;

      if (Number(currentItem.amount) > maxAmountForCurrent) {
        Swal.fire({
          icon: "error",
          title: "Exceso de monto",
          text: "La suma de los montos no puede exceder el adelanto.",
        });
        currentItem.amount = maxAmountForCurrent;
      }
    },
    mtd_action: function () {
      const totalAmount = this.data_metodo_pago.reduce((sum, item) => {
        return sum + Number(item.amount || 0);
      }, 0);

      if (totalAmount < Number(this.localAdvancePayment)) {
        Swal.fire({
          icon: "error",
          title: "Monto",
          text: "La suma de los montos no coincide con el adelanto.",
        });
      } else {
        const filledPayments = this.data_metodo_pago.filter(
          (item) => Number(item.amount) > 0
        );
        this.$emit("submitPaymentData", { filledPayments, fech_advance: this.fech_advance, quote: this.quote.id, typeRecording:this.typeRecording});
        this.data_metodo_pago = [];
        this.mtdClose();
      }
    },
    validateAdvancePayment() {
      const value = Number(this.localAdvancePayment);

      if (value < 0) {
        Swal.fire({
          icon: "error",
          title: "Valor inválido",
          text: "El adelanto no puede ser negativo.",
        });
        this.localAdvancePayment = "";
      } else if (value > Number(this.total_quote)) {
        Swal.fire({
          icon: "warning",
          title: "Exceso de monto",
          text: `El adelanto no puede ser mayor a ${this.total_quote}.`,
        });
        this.localAdvancePayment = this.total_quote;
      }
    },

  },
};
</script>
<style scoped>
.bg-purple {
  background-color: #00003a;
}

.bg-white {
  background-color: white;
}

.bg-gris {
  background-color: #dee2e6;
}

.color-white {
  color: white;
}

.color-black {
  color: black;
}

.font-bold {
  font-weight: bold;
}

.container-type {
  height: 40px;
}

.container-type:hover {
  background-color: #17a2b8;
  /* bg-info */
  cursor: pointer;
}

.text {
  margin: auto;
}
</style>
